import { getDetailsMatchingStep } from './getDetailsMatchingStep'
import {
  RoleCategoriesConfig,
  ValidationSubmissionConfigurationResponse
} from '@percent/admin-dashboard/api/actions/validationSubmissions/validationSubmissions.types'

export const getDeterministicRoleCategories = (
  config?: ValidationSubmissionConfigurationResponse | null
): RoleCategoriesConfig | undefined => {
  const detailsMatching = getDetailsMatchingStep(config)
  const roleCategories = detailsMatching?.roleCategories

  if (detailsMatching?.mode !== 'deterministic' || !roleCategories) {
    return undefined
  }

  return {
    accepted: roleCategories.accepted ?? [],
    rejected: roleCategories.rejected ?? []
  }
}
